var babelPluginFlowReactPropTypes_proptype_DOMRange = require("../types.js").babelPluginFlowReactPropTypes_proptype_DOMRange || require("react").PropTypes.any;

// Import the DOM-related types from the parent directory, and re-export them
// to the UI code.


var babelPluginFlowReactPropTypes_proptype_DOMHighlightSet = require("../types.js").babelPluginFlowReactPropTypes_proptype_DOMHighlightSet || require("react").PropTypes.any;

var babelPluginFlowReactPropTypes_proptype_DOMHighlight = require("../types.js").babelPluginFlowReactPropTypes_proptype_DOMHighlight || require("react").PropTypes.any;

Object.defineProperty(module.exports, "babelPluginFlowReactPropTypes_proptype_Position", require("react").PropTypes.shape({
    left: require("react").PropTypes.number.isRequired,
    top: require("react").PropTypes.number.isRequired
}));
Object.defineProperty(module.exports, "babelPluginFlowReactPropTypes_proptype_ZIndexes", require("react").PropTypes.shape({
    aboveContent: require("react").PropTypes.number.isRequired,
    belowContent: require("react").PropTypes.number.isRequired
}));


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/highlighting/ui/types.js
 ** module id = 350
 ** module chunks = 0 1
 **/